var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 10.38-6.996 7.118Q4.511 18 3.75 18t-1.256-.502T2 16.221t.493-1.278l8.251-8.395Q11.284 6 12 6q.717 0 1.256.548l8.25 8.395q.495.502.494 1.278 0 .775-.493 1.277-.494.502-1.256.502t-1.256-.502z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpFill);
export default __webpack_public_path__ + "static/media/chevron_up_fill.d4533885bda416deb2009cde2c0ee5f8.svg";
export { ForwardRef as ReactComponent };